import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
// Core Domain Search API Client Extension

import { combineApiConfigs, createApiClient, createQueriesConfig } from '@wix/premium-fed-sdk/@apis-infra-react';
import { createModuleExtension } from '@wix/premium-fed-sdk/@premium-module';
import { CoreDomainSearchApiConfig } from '../../backend';
import { getKeywords } from '../../backend/queries';
export const CoreDomainSearchConfig = createQueriesConfig({
  getKeywords: {
    isMutating: false,
    errorCodesMap: {
      statusCodeError: {}
    },
    queryFn: getKeywords
  }
});
export const apiConfig = combineApiConfigs(CoreDomainSearchApiConfig, CoreDomainSearchConfig);

// Single API Client created from the config
const _createApiClient = createApiClient(apiConfig),
  Provider = _createApiClient.Provider,
  backend = _objectWithoutPropertiesLoose(_createApiClient, ["Provider"]);

// Single API Client Extension
export { Provider, backend };
export const CoreDomainSearchApiClientExtension = createModuleExtension({
  extensionName: 'coreDomainSearchBackend',
  internals: {
    backend
  },
  Provider
});
//# sourceMappingURL=CoreDomainSearchApiClientExtension.js.map